<template>
<section class="apk-safety">
  <h2 class="apk-safety__title">Is Secure VPN APK Safe?</h2>
  <div class="apk-safety__body">
    <p>
      Secure VPN APK is designed to provide a safer way to access the internet. The app uses secure connections to help protect your online activity and improve privacy while browsing.
    </p>
    <p>
      Before installation, always make sure you download the APK from a reliable source and keep the app updated to the latest version for better security and performance.
    </p>
  </div>
</section>
</template>

<script>
export default {
  name: 'ApkSafetySection',
}
</script>

<style lang="scss" scoped>
.apk-safety {
  padding: 28px 32px;
  border-radius: 24px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 241, 255, 0.98) 100%);
  box-shadow: 0 12px 32px rgba(109, 74, 255, 0.06);
  box-sizing: border-box;
}

.apk-safety__title {
  margin: 0 0 16px;
  text-align: left;
  font-size: clamp(24px, 2.8vw, 32px);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--vpn-ink, #1f2430);
  font-weight: 800;
}

.apk-safety__body {
  width: 100%;

  p {
    margin: 0 0 14px;
    width: 100%;
    max-width: 100%;
    text-align: left;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 15px;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 768px) {
  .apk-safety {
    padding: 18px 14px;
    border-radius: 16px;
  }

  .apk-safety__title {
    margin-bottom: 12px;
    font-size: clamp(20px, 5.5vw, 26px);
  }

  .apk-safety__body p {
    font-size: 14px;
    line-height: 1.65;
  }
}
</style>
